// extracted by mini-css-extract-plugin
module.exports = {"root":"StarRating_root__PCJ5M"};